import { determineSelector, getResource, readUrl } from "./api";

// Single-row read of a product's profile-completion score (the `product_completion_scores`
// PostgREST view — keyed on the product PromoEntity's id, not a profile id). Mirrors
// expert_completion_scores.js's `getById` shape, the product-side sibling.
const getById = async (productId) => {
  const selector = determineSelector(productId, { keyId: "id" });
  const url = readUrl("product_completion_scores", { selector });
  return getResource(url);
};

export default { getById };
